export const appTheme = {
    token: {
        colorPrimary: "#1a1a1a",
        colorBgContainer: "#ffffff",
        colorText: "#1a1a1a",
        colorTextSecondary: "#666666",
        colorLink: "#1a1a1a",
        colorLinkHover: "#666666",
        colorBorder: "#e0e0e0",
        borderRadius: 2,
        fontFamily:
            "MainFonts, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    },
    components: {
        Button: {
            primaryColor: "#ffffff",
            colorPrimary: "#1a1a1a",
            colorPrimaryHover: "#333333",
            colorPrimaryActive: "#000000",
            defaultBorderColor: "#1a1a1a",
            defaultColor: "#1a1a1a",
        },
        Modal: {
            titleColor: "#1a1a1a",
            headerBg: "#f8f8f8",
        },
        Drawer: {
            colorBgElevated: "#f8f8f8",
        },
        Input: {
            activeBorderColor: "#1a1a1a",
            hoverBorderColor: "#666666",
        },
        DatePicker: {
            activeBorderColor: "#1a1a1a",
            hoverBorderColor: "#666666",
        },
    },
};
